import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~/shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface GHLCustomField {
  id: string;
  value: string;
}

export interface GHLContact {
  id: string;
  firstName?: string;
  lastName?: string;
  firstNameLowerCase: string;
  lastNameLowerCase: string;
  email: string | null;
  phone: string;
  phoneLabel: string;
  additionalPhones: Array<string>;
  additionalEmails: Array<string>;
  address: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
  dateOfBirth: number;
  businessName: string | null;
  companyName: string | null;
  website: string | null;
  type: string;
  source: string | null;
  locationId: string;
  assignedTo: string | null;
  dnd: boolean;
  validEmail: boolean | null;
  customFields: Array<GHLCustomField>;
  tags: Array<string>;
  followers: Array<string>;
  dateAdded: string;
  dateUpdated: string;
}

const ghlSearchContacts = async (
  firstName: string,
  lastName: string,
  email: string,
) => {
  const response = await baseAPI.get<{ contacts: Array<GHLContact> }>(
    `/ghl_auth/contacts?firstName=${firstName}&lastName=${lastName}&email=${email}`,
  );
  return response.data.contacts;
};

export const useGhlSearchContacts = (
  firstName: string,
  lastName: string,
  email: string,
  enabled = false,
) => {
  return useQuery({
    queryKey: [KEYS.GHL_CONTACTS, firstName, lastName, email],
    queryFn: () => ghlSearchContacts(firstName, lastName, email),
    enabled:
      enabled &&
      (firstName.length >= 3 || lastName.length >= 3 || email.length >= 3),
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });
};
